import api from "./api";

interface IInvoiceProps { 
    id: number;
    finished_at: Date;
    accumulated: number;
    is_closed: boolean;
    signatures: number;
    transfer_estimate: number;
    value_per_material: number;
    partners: any[];
}

export const overview = async (date: string) => {
    const { data } = await api.get<IInvoiceProps>(`/billing/invoice/?date=${date}`);

    return data
}


export const closeBilling = async (id: number | string) => { 
    const { data } = await api.patch(`/billing/close_invoice/${id}`, {is_closed: true});

    return data
}

